import React from 'react';
import { TrendingUp, Zap, AlertCircle } from 'lucide-react';
import mockData from '../mock';

const iconMap = {
  TrendingUp: TrendingUp,
  Zap: Zap,
  AlertCircle: AlertCircle
};

const ProblemSection = () => {
  const { problems } = mockData;

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Tired of These Problems?
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            You're not alone. Every Odisha household faces these challenges daily.
          </p>
        </div>

        {/* Problems Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {problems.map((problem, index) => {
            const Icon = iconMap[problem.icon];
            return (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg card-hover border-t-4 border-red-500"
              >
                <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-6">
                  <Icon className="w-8 h-8 text-red-600" />
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {problem.title}
                </h3>
                <p className="text-gray-600 text-lg leading-relaxed">
                  {problem.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;